import { Injectable } from '@angular/core';

/**
 * In-memory store of scroll positions keyed by a container id.
 *
 * As a root singleton it survives component recreation (e.g. router
 * navigation), but resets on a full page reload — the desired behaviour for
 * scroll restoration.
 */
@Injectable({ providedIn: 'root' })
export class ScrollPositionStore {
  private readonly positions = new Map<string, number>();

  set(key: string, position: number): void {
    this.positions.set(key, position);
  }

  get(key: string): number {
    return this.positions.get(key) ?? 0;
  }
}
